import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { StoreModule } from '@ngrx/store';
import { EffectsModule } from '@ngrx/effects';
import { appReducer } from './+state/vehicle.reducer';
import { vehicleInitialState } from './+state/vehicle.init';
import { VehicleEffects } from './+state/vehicle.effects';
import { VehiclesEffects } from './+state/vehicles/vehicles.effects';
import { VehicleStateService } from './vehicle-state.service';
@NgModule({
  imports: [
    CommonModule,
    StoreModule.forFeature('vehicle', appReducer, {}),
    EffectsModule.forFeature([VehicleEffects, VehiclesEffects])
  ],
  providers: [VehicleEffects, VehiclesEffects, VehicleStateService]
})
export class XsrVehicleModule {}
